import React from 'react';
import { ContentSpace } from 'module/Model/Content';
import { createPureComponent } from 'module/Common';

type Props = {
  item: ContentSpace;
};

export const Space = createPureComponent<Props>('Space', ({ item }) => {
  return <div style={{ height: item.size, pointerEvents: 'none' }} />;
});



// WEBPACK FOOTER //
// ./src/module/View/Content/component/ContentItems/items/Space.tsx